import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { useQueryResource } from '@hooks';
import { OffsetPaginatedResource, PeriscopeSfProfile, SonarObjectType } from '@sonar-software/sonar-ts-types';
import {
	paginationDefaultQueryParams,
	paginationFallbackQueryParams,
	PaginationQueryParams,
	PeriscopePaginatedList
} from '..';
import { PeriscopeProfileList, ProfileSearch, ProfileSearchQueryParams } from '.';
import React, { useCallback } from 'react';

type Resource = OffsetPaginatedResource<PeriscopeSfProfile>;
export type SearchableProfileListQueryParams = PaginationQueryParams & ProfileSearchQueryParams;

export interface SearchableProfileListProps {
	parentIndex: number;
	showTitle?: boolean;
	uri: string;
}

export const SearchableProfileList: React.FC<SearchableProfileListProps> = ({ parentIndex, showTitle, uri }) => {
	const { loading, resource, queryParams, updateParams } = useQueryResource<
		Resource,
		SearchableProfileListQueryParams
	>({
		defaultParams: {
			...paginationDefaultQueryParams,
			hasEditAccess: null
		},
		fallbackParams: paginationFallbackQueryParams,
		uri
	});

	const renderList = useCallback(
		(items: PeriscopeSfProfile[]) =>
			<PeriscopeProfileList
				items={ items }
				parentIndex={ parentIndex }
				sonarObjectType={ SonarObjectType.SalesforceProfile } />
		,
		[ parentIndex ]
	);

	return (
		<>
			<ProfileSearch onChange={ updateParams } />
			<PeriscopePaginatedList
				list={ renderList }
				loading={ loading }
				onChange={ updateParams }
				queryParams={ queryParams }
				resource={ resource }
				title={ showTitle ? PERISCOPE_TAB_TYPES.PROFILES : '' } />
		</>
	);
};
